import { radioGroupStyles as fastSegmentedControlStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationSegmentedControlStyles = (context, definition) => css `
  ${fastSegmentedControlStyles(context, definition)}
  ::slotted(foundation-segmented-item:first-of-type) {
    border-radius: calc(var(--control-corner-radius) * 1px) 0 0
      calc(var(--control-corner-radius) * 1px);
    border-right-width: 0;
  }

  ::slotted(foundation-segmented-item:last-of-type) {
    border-radius: 0 calc(var(--control-corner-radius) * 1px)
      calc(var(--control-corner-radius) * 1px) 0;
    border-left-width: 0;
  }
`;
